export type ProxiserveHeatingType = 'gas' | 'propane' | 'oil' | 'heatPump' | 'reversibleAirConditioning'

const gasZipcodes = new Set([
  '01090',
  '01120',
  '01140',
  '01150',
  '01330',
  '01360',
  '01390',
  '01480',
  '01600',
  '01700',
  '01800',
  '01990',
  '02000',
  '02100',
  '02110',
  '02120',
  '02130',
  '02140',
  '02150',
  '02170',
  '02200',
  '02210',
  '02220',
  '02230',
  '02240',
  '02250',
  '02260',
  '02270',
  '02290',
  '02300',
  '02310',
  '02320',
  '02330',
  '02340',
  '02350',
  '02360',
  '02370',
  '02380',
  '02390',
  '02400',
  '02410',
  '02420',
  '02430',
  '02440',
  '02450',
  '02460',
  '02470',
  '02480',
  '02490',
  '02500',
  '02510',
  '02520',
  '02540',
  '02550',
  '02570',
  '02580',
  '02590',
  '02600',
  '02610',
  '02620',
  '02630',
  '02640',
  '02650',
  '02670',
  '02680',
  '02690',
  '02700',
  '02720',
  '02760',
  '02790',
  '02800',
  '02810',
  '02820',
  '02830',
  '02840',
  '02850',
  '02860',
  '02870',
  '02880',
  '07000',
  '07130',
  '07210',
  '07240',
  '07250',
  '07300',
  '07340',
  '07350',
  '07360',
  '07370',
  '07440',
  '07500',
  '07610',
  '07800',
  '08000',
  '08090',
  '08110',
  '08120',
  '08130',
  '08140',
  '08150',
  '08160',
  '08170',
  '08200',
  '08210',
  '08220',
  '08230',
  '08240',
  '08250',
  '08260',
  '08270',
  '08290',
  '08300',
  '08310',
  '08320',
  '08330',
  '08350',
  '08360',
  '08370',
  '08380',
  '08390',
  '08400',
  '08410',
  '08430',
  '08440',
  '08450',
  '08460',
  '08500',
  '08600',
  '08700',
  '08800',
  '10000',
  '10100',
  '10110',
  '10120',
  '10130',
  '10140',
  '10150',
  '10160',
  '10170',
  '10180',
  '10190',
  '10200',
  '10210',
  '10220',
  '10230',
  '10240',
  '10250',
  '10260',
  '10270',
  '10280',
  '10290',
  '10300',
  '10310',
  '10320',
  '10330',
  '10340',
  '10350',
  '10360',
  '10370',
  '10380',
  '10390',
  '10400',
  '10410',
  '10420',
  '10430',
  '10440',
  '10450',
  '10500',
  '10510',
  '10600',
  '10700',
  '10800',
  '11000',
  '11100',
  '11110',
  '11120',
  '11130',
  '11140',
  '11150',
  '11160',
  '11170',
  '11190',
  '11200',
  '11210',
  '11220',
  '11230',
  '11240',
  '11250',
  '11260',
  '11270',
  '11290',
  '11300',
  '11310',
  '11320',
  '11330',
  '11340',
  '11350',
  '11360',
  '11370',
  '11380',
  '11390',
  '11400',
  '11410',
  '11420',
  '11430',
  '11440',
  '11480',
  '11490',
  '11500',
  '11510',
  '11540',
  '11560',
  '11570',
  '11580',
  '11590',
  '11600',
  '11610',
  '11620',
  '11700',
  '11800',
  '13001',
  '13002',
  '13003',
  '13004',
  '13005',
  '13006',
  '13007',
  '13008',
  '13009',
  '13010',
  '13011',
  '13012',
  '13013',
  '13014',
  '13015',
  '13016',
  '13080',
  '13090',
  '13100',
  '13103',
  '13104',
  '13105',
  '13109',
  '13110',
  '13111',
  '13112',
  '13114',
  '13117',
  '13119',
  '13120',
  '13121',
  '13122',
  '13123',
  '13124',
  '13126',
  '13127',
  '13129',
  '13130',
  '13140',
  '13150',
  '13160',
  '13170',
  '13180',
  '13190',
  '13200',
  '13210',
  '13220',
  '13230',
  '13240',
  '13250',
  '13260',
  '13270',
  '13280',
  '13290',
  '13300',
  '13320',
  '13330',
  '13340',
  '13360',
  '13370',
  '13380',
  '13390',
  '13400',
  '13410',
  '13420',
  '13430',
  '13440',
  '13450',
  '13460',
  '13470',
  '13480',
  '13490',
  '13500',
  '13510',
  '13520',
  '13530',
  '13540',
  '13550',
  '13560',
  '13570',
  '13580',
  '13590',
  '13600',
  '13610',
  '13620',
  '13630',
  '13640',
  '13650',
  '13660',
  '13670',
  '13680',
  '13690',
  '13700',
  '13710',
  '13720',
  '13730',
  '13740',
  '13750',
  '13760',
  '13770',
  '13780',
  '13790',
  '13800',
  '13810',
  '13820',
  '13821',
  '13830',
  '13840',
  '13850',
  '13860',
  '13870',
  '13880',
  '13890',
  '13910',
  '13920',
  '13940',
  '13950',
  '13960',
  '13990',
  '14000',
  '14100',
  '14110',
  '14111',
  '14112',
  '14113',
  '14114',
  '14117',
  '14120',
  '14121',
  '14123',
  '14130',
  '14140',
  '14150',
  '14160',
  '14170',
  '14190',
  '14200',
  '14210',
  '14220',
  '14230',
  '14240',
  '14250',
  '14260',
  '14270',
  '14280',
  '14290',
  '14310',
  '14320',
  '14330',
  '14340',
  '14350',
  '14360',
  '14370',
  '14380',
  '14390',
  '14400',
  '14410',
  '14420',
  '14430',
  '14440',
  '14450',
  '14460',
  '14470',
  '14480',
  '14490',
  '14500',
  '14510',
  '14520',
  '14530',
  '14540',
  '14550',
  '14570',
  '14590',
  '14600',
  '14610',
  '14620',
  '14630',
  '14640',
  '14650',
  '14670',
  '14680',
  '14690',
  '14700',
  '14710',
  '14730',
  '14740',
  '14750',
  '14760',
  '14770',
  '14780',
  '14790',
  '14800',
  '14810',
  '14830',
  '14840',
  '14850',
  '14860',
  '14880',
  '14910',
  '14920',
  '14930',
  '14940',
  '14950',
  '14960',
  '14970',
  '14980',
  '14990',
  '17000',
  '17100',
  '17110',
  '17111',
  '17113',
  '17132',
  '17137',
  '17138',
  '17139',
  '17140',
  '17170',
  '17180',
  '17190',
  '17200',
  '17220',
  '17230',
  '17250',
  '17290',
  '17300',
  '17310',
  '17320',
  '17330',
  '17340',
  '17350',
  '17370',
  '17380',
  '17390',
  '17400',
  '17410',
  '17420',
  '17430',
  '17440',
  '17450',
  '17480',
  '17530',
  '17540',
  '17550',
  '17560',
  '17570',
  '17580',
  '17590',
  '17610',
  '17620',
  '17630',
  '17640',
  '17670',
  '17690',
  '17700',
  '17730',
  '17740',
  '17750',
  '17780',
  '17810',
  '17840',
  '17870',
  '17880',
  '17890',
  '17920',
  '17940',
  '18000',
  '18100',
  '18110',
  '18120',
  '18130',
  '18140',
  '18160',
  '18190',
  '18200',
  '18220',
  '18230',
  '18250',
  '18290',
  '18300',
  '18310',
  '18330',
  '18340',
  '18350',
  '18380',
  '18390',
  '18400',
  '18500',
  '18510',
  '18520',
  '18570',
  '18800',
  '21000',
  '21110',
  '21120',
  '21121',
  '21130',
  '21140',
  '21150',
  '21160',
  '21170',
  '21190',
  '21200',
  '21210',
  '21220',
  '21230',
  '21240',
  '21250',
  '21260',
  '21270',
  '21290',
  '21300',
  '21310',
  '21320',
  '21330',
  '21340',
  '21350',
  '21360',
  '21370',
  '21380',
  '21390',
  '21400',
  '21410',
  '21420',
  '21430',
  '21440',
  '21450',
  '21460',
  '21470',
  '21490',
  '21500',
  '21510',
  '21520',
  '21530',
  '21540',
  '21550',
  '21560',
  '21570',
  '21580',
  '21590',
  '21600',
  '21610',
  '21630',
  '21640',
  '21690',
  '21700',
  '21760',
  '21800',
  '21820',
  '21850',
  '21910',
  '22100',
  '22130',
  '22160',
  '22230',
  '22240',
  '22250',
  '22270',
  '22300',
  '22310',
  '22350',
  '22370',
  '22380',
  '22400',
  '22420',
  '22430',
  '22490',
  '22510',
  '22550',
  '22560',
  '22630',
  '22640',
  '22650',
  '22690',
  '22700',
  '22730',
  '22750',
  '22770',
  '22780',
  '22810',
  '22830',
  '22980',
  '23430',
  '25000',
  '25110',
  '25111',
  '25113',
  '25115',
  '25120',
  '25130',
  '25140',
  '25150',
  '25160',
  '25170',
  '25190',
  '25200',
  '25210',
  '25220',
  '25230',
  '25240',
  '25250',
  '25260',
  '25270',
  '25290',
  '25300',
  '25310',
  '25320',
  '25330',
  '25340',
  '25350',
  '25360',
  '25370',
  '25380',
  '25390',
  '25400',
  '25410',
  '25420',
  '25430',
  '25440',
  '25450',
  '25460',
  '25470',
  '25480',
  '25490',
  '25500',
  '25510',
  '25520',
  '25530',
  '25550',
  '25560',
  '25570',
  '25580',
  '25600',
  '25610',
  '25620',
  '25630',
  '25640',
  '25650',
  '25660',
  '25680',
  '25690',
  '25700',
  '25720',
  '25750',
  '25770',
  '25790',
  '25800',
  '25820',
  '25840',
  '25870',
  '25920',
  '25930',
  '25960',
  '26000',
  '26100',
  '26120',
  '26140',
  '26190',
  '26200',
  '26210',
  '26240',
  '26250',
  '26260',
  '26270',
  '26300',
  '26320',
  '26330',
  '26350',
  '26380',
  '26390',
  '26400',
  '26450',
  '26500',
  '26530',
  '26540',
  '26600',
  '26730',
  '26740',
  '26750',
  '26760',
  '26800',
  '27000',
  '27100',
  '27110',
  '27120',
  '27140',
  '27150',
  '27160',
  '27170',
  '27180',
  '27190',
  '27200',
  '27220',
  '27240',
  '27290',
  '27310',
  '27320',
  '27340',
  '27350',
  '27360',
  '27370',
  '27380',
  '27400',
  '27420',
  '27430',
  '27440',
  '27450',
  '27460',
  '27470',
  '27480',
  '27490',
  '27500',
  '27510',
  '27520',
  '27530',
  '27540',
  '27550',
  '27590',
  '27600',
  '27610',
  '27620',
  '27630',
  '27640',
  '27650',
  '27660',
  '27670',
  '27680',
  '27690',
  '27700',
  '27710',
  '27720',
  '27730',
  '27740',
  '27750',
  '27760',
  '27770',
  '27780',
  '27790',
  '27800',
  '27810',
  '27830',
  '27850',
  '27860',
  '27870',
  '27890',
  '27910',
  '27920',
  '27930',
  '27940',
  '27950',
  '28140',
  '28200',
  '29000',
  '29100',
  '29120',
  '29140',
  '29150',
  '29170',
  '29180',
  '29190',
  '29200',
  '29217',
  '29233',
  '29241',
  '29246',
  '29250',
  '29252',
  '29260',
  '29280',
  '29290',
  '29340',
  '29350',
  '29360',
  '29370',
  '29380',
  '29390',
  '29400',
  '29410',
  '29420',
  '29430',
  '29440',
  '29450',
  '29460',
  '29470',
  '29480',
  '29490',
  '29500',
  '29510',
  '29520',
  '29530',
  '29550',
  '29560',
  '29590',
  '29600',
  '29610',
  '29620',
  '29630',
  '29640',
  '29650',
  '29660',
  '29670',
  '29680',
  '29690',
  '29700',
  '29710',
  '29720',
  '29730',
  '29740',
  '29750',
  '29760',
  '29770',
  '29780',
  '29790',
  '29800',
  '29810',
  '29820',
  '29830',
  '29840',
  '29850',
  '29860',
  '29870',
  '29880',
  '29890',
  '29900',
  '29910',
  '29920',
  '29930',
  '29940',
  '29950',
  '29970',
  '29980',
  '29990',
  '30000',
  '30111',
  '30114',
  '30121',
  '30126',
  '30127',
  '30128',
  '30129',
  '30131',
  '30132',
  '30133',
  '30150',
  '30190',
  '30210',
  '30220',
  '30230',
  '30240',
  '30250',
  '30260',
  '30290',
  '30300',
  '30310',
  '30320',
  '30330',
  '30350',
  '30360',
  '30390',
  '30400',
  '30420',
  '30470',
  '30490',
  '30510',
  '30540',
  '30580',
  '30600',
  '30610',
  '30620',
  '30640',
  '30650',
  '30660',
  '30670',
  '30700',
  '30720',
  '30730',
  '30740',
  '30800',
  '30820',
  '30840',
  '30870',
  '30900',
  '30920',
  '30980',
  '31000',
  '31100',
  '31120',
  '31130',
  '31140',
  '31150',
  '31170',
  '31180',
  '31190',
  '31200',
  '31240',
  '31270',
  '31280',
  '31290',
  '31300',
  '31320',
  '31330',
  '31340',
  '31370',
  '31380',
  '31390',
  '31400',
  '31410',
  '31450',
  '31460',
  '31470',
  '31490',
  '31500',
  '31520',
  '31530',
  '31550',
  '31560',
  '31570',
  '31590',
  '31600',
  '31620',
  '31650',
  '31660',
  '31670',
  '31700',
  '31750',
  '31770',
  '31780',
  '31790',
  '31810',
  '31820',
  '31830',
  '31840',
  '31850',
  '31860',
  '31870',
  '31880',
  '32340',
  '32480',
  '32490',
  '32600',
  '32700',
  '33000',
  '33100',
  '33110',
  '33112',
  '33114',
  '33115',
  '33120',
  '33125',
  '33126',
  '33127',
  '33130',
  '33133',
  '33138',
  '33140',
  '33141',
  '33150',
  '33160',
  '33170',
  '33185',
  '33200',
  '33230',
  '33240',
  '33250',
  '33260',
  '33270',
  '33290',
  '33300',
  '33310',
  '33320',
  '33330',
  '33350',
  '33360',
  '33370',
  '33380',
  '33390',
  '33400',
  '33410',
  '33420',
  '33440',
  '33450',
  '33460',
  '33470',
  '33480',
  '33490',
  '33500',
  '33510',
  '33520',
  '33530',
  '33540',
  '33550',
  '33560',
  '33570',
  '33600',
  '33610',
  '33620',
  '33640',
  '33650',
  '33670',
  '33680',
  '33700',
  '33710',
  '33720',
  '33740',
  '33750',
  '33760',
  '33770',
  '33800',
  '33810',
  '33830',
  '33850',
  '33860',
  '33870',
  '33880',
  '33910',
  '33920',
  '33950',
  '33970',
  '33980',
  '34000',
  '34070',
  '34080',
  '34090',
  '34110',
  '34120',
  '34130',
  '34140',
  '34150',
  '34160',
  '34170',
  '34190',
  '34200',
  '34230',
  '34240',
  '34250',
  '34270',
  '34280',
  '34290',
  '34300',
  '34310',
  '34320',
  '34340',
  '34350',
  '34360',
  '34370',
  '34380',
  '34390',
  '34400',
  '34410',
  '34420',
  '34430',
  '34440',
  '34450',
  '34460',
  '34470',
  '34480',
  '34490',
  '34500',
  '34510',
  '34520',
  '34530',
  '34540',
  '34550',
  '34560',
  '34570',
  '34590',
  '34600',
  '34610',
  '34620',
  '34630',
  '34660',
  '34670',
  '34680',
  '34690',
  '34700',
  '34710',
  '34720',
  '34725',
  '34730',
  '34740',
  '34750',
  '34760',
  '34770',
  '34790',
  '34800',
  '34810',
  '34820',
  '34830',
  '34850',
  '34880',
  '34920',
  '34970',
  '34980',
  '34990',
  '35000',
  '35111',
  '35113',
  '35114',
  '35120',
  '35130',
  '35131',
  '35132',
  '35133',
  '35134',
  '35135',
  '35136',
  '35137',
  '35140',
  '35150',
  '35160',
  '35170',
  '35190',
  '35200',
  '35210',
  '35220',
  '35230',
  '35235',
  '35240',
  '35250',
  '35260',
  '35270',
  '35290',
  '35310',
  '35320',
  '35330',
  '35340',
  '35350',
  '35360',
  '35370',
  '35380',
  '35390',
  '35400',
  '35410',
  '35430',
  '35440',
  '35450',
  '35460',
  '35470',
  '35480',
  '35490',
  '35500',
  '35510',
  '35520',
  '35530',
  '35540',
  '35560',
  '35580',
  '35590',
  '35610',
  '35620',
  '35630',
  '35640',
  '35650',
  '35680',
  '35690',
  '35700',
  '35720',
  '35730',
  '35740',
  '35750',
  '35760',
  '35770',
  '35780',
  '35800',
  '35830',
  '35850',
  '35870',
  '35890',
  '35960',
  '36260',
  '37000',
  '37100',
  '37170',
  '37200',
  '37210',
  '37230',
  '37250',
  '37260',
  '37270',
  '37300',
  '37310',
  '37320',
  '37390',
  '37400',
  '37510',
  '37520',
  '37540',
  '37550',
  '37700',
  '38000',
  '38070',
  '38080',
  '38090',
  '38100',
  '38113',
  '38119',
  '38120',
  '38121',
  '38130',
  '38134',
  '38138',
  '38140',
  '38144',
  '38160',
  '38170',
  '38180',
  '38190',
  '38200',
  '38210',
  '38220',
  '38230',
  '38240',
  '38250',
  '38280',
  '38290',
  '38300',
  '38320',
  '38330',
  '38340',
  '38360',
  '38370',
  '38380',
  '38400',
  '38410',
  '38420',
  '38430',
  '38440',
  '38450',
  '38460',
  '38470',
  '38500',
  '38530',
  '38540',
  '38560',
  '38570',
  '38590',
  '38600',
  '38610',
  '38620',
  '38640',
  '38650',
  '38660',
  '38670',
  '38690',
  '38700',
  '38730',
  '38760',
  '38770',
  '38780',
  '38790',
  '38800',
  '38830',
  '38850',
  '38880',
  '38890',
  '38920',
  '38950',
  '38960',
  '40130',
  '40140',
  '40150',
  '40160',
  '40220',
  '40230',
  '40300',
  '40320',
  '40390',
  '40440',
  '40460',
  '40480',
  '40510',
  '40530',
  '40600',
  '40800',
  '41240',
  '41370',
  '42000',
  '42100',
  '42110',
  '42130',
  '42131',
  '42140',
  '42150',
  '42152',
  '42160',
  '42170',
  '42210',
  '42220',
  '42230',
  '42240',
  '42270',
  '42290',
  '42320',
  '42330',
  '42340',
  '42350',
  '42380',
  '42390',
  '42400',
  '42420',
  '42450',
  '42480',
  '42490',
  '42500',
  '42530',
  '42560',
  '42570',
  '42580',
  '42600',
  '42610',
  '42650',
  '42660',
  '42680',
  '42700',
  '42740',
  '42800',
  '42810',
  '43000',
  '43110',
  '43120',
  '43130',
  '43140',
  '43150',
  '43200',
  '43240',
  '43250',
  '43260',
  '43270',
  '43320',
  '43330',
  '43340',
  '43350',
  '43370',
  '43410',
  '43420',
  '43430',
  '43490',
  '43510',
  '43520',
  '43550',
  '43580',
  '43600',
  '43620',
  '43700',
  '43750',
  '43770',
  '43800',
  '43810',
  '44000',
  '44100',
  '44115',
  '44116',
  '44117',
  '44118',
  '44119',
  '44120',
  '44130',
  '44140',
  '44150',
  '44160',
  '44170',
  '44190',
  '44200',
  '44210',
  '44220',
  '44230',
  '44240',
  '44250',
  '44260',
  '44270',
  '44300',
  '44310',
  '44320',
  '44330',
  '44340',
  '44350',
  '44360',
  '44370',
  '44380',
  '44390',
  '44400',
  '44410',
  '44420',
  '44430',
  '44440',
  '44450',
  '44470',
  '44480',
  '44490',
  '44500',
  '44510',
  '44521',
  '44522',
  '44530',
  '44550',
  '44560',
  '44570',
  '44580',
  '44600',
  '44610',
  '44620',
  '44630',
  '44640',
  '44650',
  '44660',
  '44680',
  '44690',
  '44700',
  '44710',
  '44720',
  '44730',
  '44740',
  '44750',
  '44760',
  '44770',
  '44780',
  '44800',
  '44810',
  '44830',
  '44840',
  '44850',
  '44860',
  '44880',
  '44980',
  '45000',
  '45100',
  '45110',
  '45120',
  '45130',
  '45140',
  '45150',
  '45160',
  '45170',
  '45190',
  '45200',
  '45210',
  '45220',
  '45230',
  '45240',
  '45250',
  '45260',
  '45270',
  '45290',
  '45300',
  '45310',
  '45320',
  '45330',
  '45340',
  '45360',
  '45370',
  '45380',
  '45390',
  '45400',
  '45410',
  '45420',
  '45430',
  '45450',
  '45460',
  '45470',
  '45480',
  '45490',
  '45500',
  '45510',
  '45520',
  '45530',
  '45550',
  '45560',
  '45570',
  '45590',
  '45600',
  '45620',
  '45630',
  '45640',
  '45650',
  '45680',
  '45700',
  '45720',
  '45730',
  '45740',
  '45750',
  '45760',
  '45770',
  '45800',
  '47000',
  '47110',
  '47130',
  '47140',
  '47150',
  '47160',
  '47190',
  '47210',
  '47220',
  '47230',
  '47240',
  '47260',
  '47270',
  '47290',
  '47300',
  '47310',
  '47320',
  '47330',
  '47340',
  '47360',
  '47370',
  '47380',
  '47390',
  '47400',
  '47410',
  '47430',
  '47440',
  '47450',
  '47470',
  '47480',
  '47500',
  '47510',
  '47520',
  '47550',
  '47600',
  '49000',
  '49070',
  '49080',
  '49100',
  '49110',
  '49120',
  '49122',
  '49123',
  '49124',
  '49125',
  '49130',
  '49140',
  '49150',
  '49160',
  '49170',
  '49190',
  '49220',
  '49230',
  '49240',
  '49250',
  '49260',
  '49270',
  '49280',
  '49290',
  '49300',
  '49310',
  '49320',
  '49330',
  '49340',
  '49350',
  '49360',
  '49370',
  '49380',
  '49390',
  '49400',
  '49410',
  '49420',
  '49430',
  '49440',
  '49450',
  '49460',
  '49480',
  '49490',
  '49500',
  '49510',
  '49520',
  '49530',
  '49540',
  '49560',
  '49570',
  '49590',
  '49600',
  '49610',
  '49620',
  '49630',
  '49640',
  '49650',
  '49660',
  '49670',
  '49680',
  '49690',
  '49700',
  '49710',
  '49730',
  '49740',
  '49750',
  '49770',
  '49800',
  '51000',
  '51120',
  '51130',
  '51190',
  '51210',
  '51230',
  '51240',
  '51250',
  '51260',
  '51270',
  '51290',
  '51300',
  '51310',
  '51320',
  '51330',
  '51340',
  '51460',
  '51470',
  '51510',
  '51520',
  '51600',
  '51700',
  '51800',
  '52100',
  '54000',
  '54100',
  '54110',
  '54111',
  '54112',
  '54113',
  '54114',
  '54115',
  '54116',
  '54118',
  '54119',
  '54120',
  '54121',
  '54122',
  '54123',
  '54129',
  '54130',
  '54134',
  '54135',
  '54136',
  '54140',
  '54150',
  '54160',
  '54170',
  '54180',
  '54190',
  '54200',
  '54210',
  '54220',
  '54230',
  '54240',
  '54250',
  '54260',
  '54270',
  '54280',
  '54290',
  '54300',
  '54310',
  '54320',
  '54330',
  '54340',
  '54350',
  '54360',
  '54370',
  '54380',
  '54385',
  '54390',
  '54400',
  '54410',
  '54420',
  '54425',
  '54430',
  '54440',
  '54450',
  '54460',
  '54470',
  '54480',
  '54490',
  '54500',
  '54510',
  '54520',
  '54530',
  '54540',
  '54550',
  '54560',
  '54570',
  '54580',
  '54590',
  '54600',
  '54610',
  '54620',
  '54630',
  '54640',
  '54650',
  '54660',
  '54670',
  '54680',
  '54690',
  '54700',
  '54710',
  '54720',
  '54730',
  '54740',
  '54750',
  '54760',
  '54770',
  '54780',
  '54800',
  '54810',
  '54820',
  '54830',
  '54840',
  '54850',
  '54860',
  '54870',
  '54880',
  '54890',
  '54910',
  '54920',
  '54930',
  '54940',
  '54950',
  '54960',
  '54970',
  '54980',
  '54990',
  '56000',
  '56100',
  '56120',
  '56130',
  '56140',
  '56150',
  '56160',
  '56190',
  '56200',
  '56220',
  '56230',
  '56240',
  '56250',
  '56260',
  '56270',
  '56290',
  '56300',
  '56310',
  '56320',
  '56330',
  '56340',
  '56350',
  '56370',
  '56380',
  '56390',
  '56400',
  '56410',
  '56420',
  '56430',
  '56440',
  '56450',
  '56460',
  '56470',
  '56480',
  '56490',
  '56500',
  '56510',
  '56520',
  '56530',
  '56540',
  '56550',
  '56570',
  '56580',
  '56600',
  '56610',
  '56620',
  '56630',
  '56640',
  '56650',
  '56660',
  '56670',
  '56680',
  '56690',
  '56700',
  '56730',
  '56740',
  '56750',
  '56760',
  '56770',
  '56780',
  '56800',
  '56840',
  '56850',
  '56860',
  '56870',
  '56880',
  '56890',
  '56910',
  '56920',
  '56930',
  '56950',
  '57000',
  '57050',
  '57070',
  '57100',
  '57120',
  '57130',
  '57140',
  '57150',
  '57155',
  '57160',
  '57170',
  '57175',
  '57180',
  '57185',
  '57190',
  '57200',
  '57220',
  '57230',
  '57240',
  '57245',
  '57250',
  '57255',
  '57260',
  '57270',
  '57280',
  '57290',
  '57300',
  '57310',
  '57320',
  '57330',
  '57340',
  '57350',
  '57360',
  '57365',
  '57370',
  '57380',
  '57385',
  '57390',
  '57400',
  '57405',
  '57410',
  '57412',
  '57415',
  '57420',
  '57430',
  '57440',
  '57445',
  '57450',
  '57455',
  '57460',
  '57470',
  '57480',
  '57490',
  '57500',
  '57510',
  '57515',
  '57520',
  '57525',
  '57530',
  '57535',
  '57540',
  '57550',
  '57560',
  '57565',
  '57570',
  '57580',
  '57590',
  '57600',
  '57620',
  '57630',
  '57635',
  '57640',
  '57645',
  '57650',
  '57655',
  '57660',
  '57670',
  '57680',
  '57685',
  '57690',
  '57700',
  '57710',
  '57720',
  '57730',
  '57740',
  '57770',
  '57780',
  '57790',
  '57800',
  '57810',
  '57815',
  '57820',
  '57830',
  '57840',
  '57850',
  '57855',
  '57860',
  '57865',
  '57870',
  '57880',
  '57890',
  '57905',
  '57910',
  '57915',
  '57920',
  '57925',
  '57930',
  '57935',
  '57940',
  '57950',
  '57960',
  '57970',
  '57980',
  '57990',
  '59000',
  '59100',
  '59110',
  '59111',
  '59112',
  '59113',
  '59114',
  '59115',
  '59116',
  '59117',
  '59118',
  '59119',
  '59120',
  '59121',
  '59122',
  '59123',
  '59124',
  '59125',
  '59126',
  '59127',
  '59128',
  '59129',
  '59130',
  '59131',
  '59132',
  '59133',
  '59134',
  '59135',
  '59136',
  '59137',
  '59138',
  '59139',
  '59140',
  '59141',
  '59142',
  '59143',
  '59144',
  '59145',
  '59146',
  '59147',
  '59148',
  '59149',
  '59150',
  '59151',
  '59152',
  '59153',
  '59154',
  '59155',
  '59156',
  '59157',
  '59158',
  '59159',
  '59160',
  '59161',
  '59162',
  '59163',
  '59164',
  '59165',
  '59166',
  '59167',
  '59168',
  '59169',
  '59170',
  '59171',
  '59172',
  '59173',
  '59174',
  '59175',
  '59176',
  '59177',
  '59178',
  '59179',
  '59180',
  '59181',
  '59182',
  '59184',
  '59185',
  '59186',
  '59187',
  '59188',
  '59189',
  '59190',
  '59191',
  '59192',
  '59193',
  '59194',
  '59195',
  '59198',
  '59199',
  '59200',
  '59210',
  '59211',
  '59212',
  '59213',
  '59214',
  '59215',
  '59216',
  '59217',
  '59218',
  '59219',
  '59220',
  '59221',
  '59222',
  '59223',
  '59224',
  '59225',
  '59226',
  '59227',
  '59229',
  '59230',
  '59231',
  '59232',
  '59233',
  '59234',
  '59235',
  '59236',
  '59237',
  '59238',
  '59239',
  '59240',
  '59241',
  '59242',
  '59243',
  '59244',
  '59245',
  '59246',
  '59247',
  '59249',
  '59250',
  '59251',
  '59252',
  '59253',
  '59254',
  '59255',
  '59258',
  '59259',
  '59260',
  '59261',
  '59262',
  '59263',
  '59264',
  '59265',
  '59266',
  '59267',
  '59268',
  '59269',
  '59270',
  '59271',
  '59272',
  '59273',
  '59274',
  '59277',
  '59278',
  '59279',
  '59280',
  '59281',
  '59282',
  '59283',
  '59284',
  '59285',
  '59286',
  '59287',
  '59288',
  '59290',
  '59292',
  '59293',
  '59294',
  '59295',
  '59296',
  '59297',
  '59299',
  '59300',
  '59310',
  '59320',
  '59330',
  '59350',
  '59360',
  '59370',
  '59380',
  '59390',
  '59400',
  '59410',
  '59420',
  '59430',
  '59440',
  '59450',
  '59460',
  '59470',
  '59480',
  '59490',
  '59491',
  '59492',
  '59493',
  '59494',
  '59495',
  '59496',
  '59500',
  '59510',
  '59520',
  '59530',
  '59540',
  '59550',
  '59551',
  '59552',
  '59553',
  '59554',
  '59560',
  '59570',
  '59580',
  '59590',
  '59600',
  '59610',
  '59620',
  '59630',
  '59640',
  '59650',
  '59660',
  '59670',
  '59680',
  '59690',
  '59700',
  '59710',
  '59720',
  '59730',
  '59740',
  '59750',
  '59760',
  '59770',
  '59777',
  '59780',
  '59790',
  '59800',
  '59810',
  '59820',
  '59830',
  '59840',
  '59850',
  '59860',
  '59870',
  '59880',
  '59890',
  '59910',
  '59920',
  '59930',
  '59940',
  '59950',
  '59960',
  '59970',
  '59980',
  '59990',
  '60000',
  '60100',
  '60110',
  '60112',
  '60113',
  '60117',
  '60119',
  '60120',
  '60123',
  '60126',
  '60127',
  '60128',
  '60129',
  '60130',
  '60134',
  '60138',
  '60140',
  '60141',
  '60149',
  '60150',
  '60153',
  '60155',
  '60157',
  '60160',
  '60162',
  '60170',
  '60173',
  '60175',
  '60180',
  '60190',
  '60200',
  '60210',
  '60220',
  '60230',
  '60240',
  '60250',
  '60260',
  '60270',
  '60280',
  '60290',
  '60300',
  '60310',
  '60320',
  '60330',
  '60340',
  '60350',
  '60360',
  '60370',
  '60380',
  '60390',
  '60400',
  '60410',
  '60420',
  '60430',
  '60440',
  '60460',
  '60480',
  '60490',
  '60500',
  '60510',
  '60520',
  '60530',
  '60540',
  '60550',
  '60560',
  '60570',
  '60580',
  '60590',
  '60600',
  '60610',
  '60620',
  '60640',
  '60650',
  '60660',
  '60680',
  '60690',
  '60700',
  '60710',
  '60730',
  '60740',
  '60750',
  '60790',
  '60800',
  '60810',
  '60820',
  '60840',
  '60850',
  '60860',
  '60870',
  '60880',
  '60890',
  '60930',
  '60940',
  '60950',
  '60960',
  '62000',
  '62100',
  '62110',
  '62112',
  '62113',
  '62114',
  '62117',
  '62118',
  '62119',
  '62120',
  '62122',
  '62126',
  '62128',
  '62129',
  '62131',
  '62132',
  '62134',
  '62136',
  '62137',
  '62138',
  '62141',
  '62142',
  '62143',
  '62144',
  '62145',
  '62147',
  '62149',
  '62150',
  '62151',
  '62152',
  '62153',
  '62155',
  '62156',
  '62157',
  '62160',
  '62161',
  '62162',
  '62164',
  '62170',
  '62172',
  '62176',
  '62179',
  '62180',
  '62182',
  '62185',
  '62187',
  '62190',
  '62196',
  '62199',
  '62200',
  '62210',
  '62215',
  '62217',
  '62218',
  '62219',
  '62220',
  '62221',
  '62223',
  '62224',
  '62230',
  '62231',
  '62232',
  '62240',
  '62250',
  '62260',
  '62280',
  '62290',
  '62300',
  '62310',
  '62320',
  '62330',
  '62340',
  '62350',
  '62360',
  '62370',
  '62380',
  '62400',
  '62410',
  '62420',
  '62430',
  '62440',
  '62460',
  '62470',
  '62480',
  '62490',
  '62500',
  '62510',
  '62520',
  '62530',
  '62540',
  '62550',
  '62560',
  '62570',
  '62575',
  '62580',
  '62590',
  '62600',
  '62610',
  '62620',
  '62630',
  '62640',
  '62650',
  '62660',
  '62670',
  '62680',
  '62700',
  '62710',
  '62720',
  '62730',
  '62740',
  '62750',
  '62780',
  '62790',
  '62800',
  '62820',
  '62830',
  '62840',
  '62850',
  '62860',
  '62880',
  '62890',
  '62910',
  '62920',
  '62930',
  '62940',
  '62950',
  '62960',
  '62970',
  '62980',
  '63000',
  '63100',
  '63110',
  '63112',
  '63113',
  '63114',
  '63115',
  '63116',
  '63117',
  '63118',
  '63119',
  '63120',
  '63122',
  '63130',
  '63140',
  '63150',
  '63160',
  '63170',
  '63190',
  '63200',
  '63210',
  '63220',
  '63230',
  '63240',
  '63250',
  '63260',
  '63270',
  '63290',
  '63300',
  '63310',
  '63320',
  '63330',
  '63340',
  '63350',
  '63360',
  '63370',
  '63380',
  '63390',
  '63400',
  '63410',
  '63420',
  '63430',
  '63440',
  '63450',
  '63460',
  '63470',
  '63480',
  '63490',
  '63500',
  '63510',
  '63520',
  '63530',
  '63540',
  '63550',
  '63560',
  '63570',
  '63580',
  '63590',
  '63600',
  '63610',
  '63620',
  '63630',
  '63640',
  '63650',
  '63660',
  '63670',
  '63680',
  '63690',
  '63700',
  '63710',
  '63720',
  '63730',
  '63740',
  '63750',
  '63760',
  '63770',
  '63780',
  '63790',
  '63800',
  '63810',
  '63820',
  '63830',
  '63840',
  '63850',
  '63870',
  '63880',
  '63890',
  '63910',
  '63920',
  '63930',
  '63940',
  '63950',
  '63960',
  '63970',
  '63980',
  '63990',
  '64000',
  '64100',
  '64110',
  '64121',
  '64122',
  '64140',
  '64150',
  '64160',
  '64170',
  '64190',
  '64200',
  '64210',
  '64230',
  '64240',
  '64250',
  '64260',
  '64290',
  '64300',
  '64310',
  '64320',
  '64330',
  '64340',
  '64350',
  '64360',
  '64370',
  '64400',
  '64410',
  '64420',
  '64450',
  '64460',
  '64480',
  '64500',
  '64510',
  '64520',
  '64530',
  '64600',
  '64640',
  '64660',
  '64680',
  '64700',
  '64780',
  '64800',
  '64870',
  '64990',
  '65000',
  '65100',
  '65270',
  '65290',
  '65310',
  '65320',
  '65360',
  '65380',
  '65390',
  '65420',
  '65430',
  '65460',
  '65490',
  '65500',
  '65560',
  '65600',
  '65690',
  '65700',
  '65800',
  '66000',
  '66100',
  '66130',
  '66140',
  '66160',
  '66170',
  '66180',
  '66190',
  '66200',
  '66220',
  '66240',
  '66250',
  '66270',
  '66280',
  '66290',
  '66300',
  '66310',
  '66320',
  '66330',
  '66350',
  '66370',
  '66380',
  '66390',
  '66400',
  '66410',
  '66420',
  '66430',
  '66440',
  '66450',
  '66460',
  '66470',
  '66480',
  '66490',
  '66510',
  '66530',
  '66540',
  '66550',
  '66560',
  '66570',
  '66600',
  '66610',
  '66620',
  '66650',
  '66660',
  '66670',
  '66680',
  '66690',
  '66700',
  '66720',
  '66730',
  '66740',
  '66750',
  '67000',
  '67100',
  '67112',
  '67113',
  '67114',
  '67115',
  '67116',
  '67117',
  '67118',
  '67120',
  '67130',
  '67140',
  '67150',
  '67170',
  '67190',
  '67200',
  '67201',
  '67202',
  '67203',
  '67204',
  '67205',
  '67206',
  '67207',
  '67210',
  '67220',
  '67230',
  '67240',
  '67260',
  '67270',
  '67280',
  '67300',
  '67310',
  '67330',
  '67350',
  '67370',
  '67380',
  '67390',
  '67400',
  '67410',
  '67420',
  '67440',
  '67450',
  '67460',
  '67480',
  '67490',
  '67500',
  '67520',
  '67530',
  '67540',
  '67550',
  '67560',
  '67570',
  '67590',
  '67600',
  '67610',
  '67620',
  '67640',
  '67650',
  '67670',
  '67680',
  '67700',
  '67710',
  '67720',
  '67730',
  '67750',
  '67760',
  '67770',
  '67790',
  '67800',
  '67810',
  '67820',
  '67840',
  '67850',
  '67860',
  '67870',
  '67880',
  '67920',
  '67960',
  '67970',
  '67980',
  '67990',
  '68000',
  '68040',
  '68100',
  '68110',
  '68116',
  '68118',
  '68120',
  '68121',
  '68124',
  '68125',
  '68126',
  '68127',
  '68128',
  '68130',
  '68140',
  '68150',
  '68160',
  '68170',
  '68180',
  '68190',
  '68200',
  '68210',
  '68220',
  '68230',
  '68240',
  '68250',
  '68260',
  '68270',
  '68280',
  '68290',
  '68300',
  '68310',
  '68320',
  '68330',
  '68340',
  '68350',
  '68360',
  '68370',
  '68380',
  '68390',
  '68400',
  '68420',
  '68440',
  '68460',
  '68470',
  '68480',
  '68490',
  '68500',
  '68510',
  '68520',
  '68530',
  '68540',
  '68550',
  '68560',
  '68570',
  '68580',
  '68590',
  '68600',
  '68610',
  '68620',
  '68630',
  '68640',
  '68650',
  '68660',
  '68680',
  '68690',
  '68700',
  '68720',
  '68730',
  '68740',
  '68750',
  '68760',
  '68770',
  '68780',
  '68790',
  '68800',
  '68820',
  '68830',
  '68840',
  '68850',
  '68870',
  '68890',
  '68910',
  '68920',
  '68950',
  '68960',
  '68970',
  '68980',
  '68990',
  '69001',
  '69002',
  '69003',
  '69004',
  '69005',
  '69006',
  '69007',
  '69008',
  '69009',
  '69100',
  '69110',
  '69115',
  '69120',
  '69124',
  '69126',
  '69130',
  '69140',
  '69150',
  '69160',
  '69170',
  '69190',
  '69200',
  '69210',
  '69220',
  '69230',
  '69250',
  '69260',
  '69270',
  '69280',
  '69290',
  '69300',
  '69320',
  '69330',
  '69340',
  '69350',
  '69360',
  '69370',
  '69380',
  '69390',
  '69400',
  '69410',
  '69420',
  '69430',
  '69440',
  '69450',
  '69460',
  '69480',
  '69490',
  '69500',
  '69510',
  '69520',
  '69530',
  '69540',
  '69550',
  '69560',
  '69570',
  '69580',
  '69600',
  '69620',
  '69630',
  '69640',
  '69650',
  '69660',
  '69670',
  '69680',
  '69700',
  '69720',
  '69730',
  '69740',
  '69760',
  '69780',
  '69800',
  '69820',
  '69830',
  '69840',
  '69870',
  '69890',
  '69910',
  '69960',
  '69970',
  '70000',
  '70100',
  '70110',
  '70120',
  '70130',
  '70140',
  '70150',
  '70160',
  '70170',
  '70180',
  '70190',
  '70200',
  '70210',
  '70220',
  '70230',
  '70240',
  '70250',
  '70270',
  '70280',
  '70290',
  '70300',
  '70310',
  '70320',
  '70360',
  '70400',
  '70440',
  '70500',
  '70600',
  '70700',
  '70800',
  '71570',
  '71680',
  '72000',
  '72100',
  '72110',
  '72120',
  '72140',
  '72150',
  '72160',
  '72170',
  '72190',
  '72200',
  '72210',
  '72220',
  '72230',
  '72240',
  '72250',
  '72260',
  '72270',
  '72290',
  '72300',
  '72310',
  '72320',
  '72330',
  '72340',
  '72350',
  '72360',
  '72370',
  '72380',
  '72390',
  '72400',
  '72430',
  '72440',
  '72450',
  '72460',
  '72470',
  '72500',
  '72510',
  '72530',
  '72540',
  '72550',
  '72560',
  '72650',
  '72700',
  '72800',
  '73000',
  '73100',
  '73110',
  '73160',
  '73170',
  '73190',
  '73200',
  '73220',
  '73230',
  '73240',
  '73250',
  '73290',
  '73330',
  '73340',
  '73360',
  '73370',
  '73390',
  '73410',
  '73420',
  '73460',
  '73470',
  '73490',
  '73520',
  '73540',
  '73610',
  '73670',
  '73790',
  '73800',
  '74000',
  '74100',
  '74150',
  '74160',
  '74210',
  '74230',
  '74240',
  '74270',
  '74290',
  '74320',
  '74330',
  '74350',
  '74370',
  '74380',
  '74410',
  '74520',
  '74540',
  '74560',
  '74570',
  '74580',
  '74600',
  '74650',
  '74800',
  '74910',
  '74930',
  '74940',
  '74960',
  '75001',
  '75002',
  '75003',
  '75004',
  '75005',
  '75006',
  '75007',
  '75008',
  '75009',
  '75010',
  '75011',
  '75012',
  '75013',
  '75014',
  '75015',
  '75016',
  '75017',
  '75018',
  '75019',
  '75020',
  '75116',
  '76000',
  '76100',
  '76110',
  '76111',
  '76113',
  '76116',
  '76117',
  '76119',
  '76120',
  '76130',
  '76133',
  '76140',
  '76150',
  '76160',
  '76170',
  '76190',
  '76200',
  '76210',
  '76220',
  '76230',
  '76240',
  '76250',
  '76260',
  '76270',
  '76280',
  '76290',
  '76300',
  '76310',
  '76320',
  '76330',
  '76340',
  '76350',
  '76360',
  '76370',
  '76380',
  '76390',
  '76400',
  '76410',
  '76420',
  '76430',
  '76440',
  '76450',
  '76460',
  '76470',
  '76480',
  '76490',
  '76500',
  '76510',
  '76520',
  '76530',
  '76540',
  '76550',
  '76560',
  '76570',
  '76580',
  '76590',
  '76600',
  '76610',
  '76620',
  '76630',
  '76640',
  '76650',
  '76660',
  '76680',
  '76690',
  '76700',
  '76710',
  '76720',
  '76730',
  '76740',
  '76750',
  '76760',
  '76770',
  '76780',
  '76790',
  '76800',
  '76810',
  '76840',
  '76850',
  '76860',
  '76870',
  '76880',
  '76890',
  '76910',
  '76920',
  '76930',
  '76940',
  '76950',
  '76960',
  '76970',
  '76980',
  '77000',
  '77090',
  '77100',
  '77111',
  '77114',
  '77115',
  '77118',
  '77120',
  '77122',
  '77123',
  '77124',
  '77126',
  '77127',
  '77130',
  '77131',
  '77133',
  '77134',
  '77135',
  '77138',
  '77139',
  '77140',
  '77141',
  '77144',
  '77145',
  '77148',
  '77150',
  '77151',
  '77154',
  '77157',
  '77160',
  '77163',
  '77164',
  '77165',
  '77166',
  '77167',
  '77169',
  '77170',
  '77171',
  '77173',
  '77174',
  '77176',
  '77177',
  '77178',
  '77181',
  '77183',
  '77184',
  '77185',
  '77186',
  '77190',
  '77200',
  '77210',
  '77220',
  '77230',
  '77240',
  '77250',
  '77260',
  '77270',
  '77280',
  '77290',
  '77300',
  '77310',
  '77320',
  '77330',
  '77340',
  '77350',
  '77360',
  '77370',
  '77380',
  '77390',
  '77400',
  '77410',
  '77420',
  '77430',
  '77440',
  '77450',
  '77460',
  '77470',
  '77480',
  '77500',
  '77510',
  '77515',
  '77520',
  '77540',
  '77550',
  '77560',
  '77570',
  '77580',
  '77590',
  '77600',
  '77610',
  '77620',
  '77630',
  '77640',
  '77650',
  '77660',
  '77670',
  '77680',
  '77690',
  '77700',
  '77710',
  '77720',
  '77730',
  '77750',
  '77760',
  '77780',
  '77810',
  '77820',
  '77830',
  '77840',
  '77850',
  '77860',
  '77870',
  '77880',
  '77890',
  '77910',
  '77920',
  '77930',
  '77940',
  '77950',
  '77970',
  '77990',
  '78000',
  '78100',
  '78110',
  '78111',
  '78112',
  '78113',
  '78114',
  '78117',
  '78120',
  '78121',
  '78124',
  '78125',
  '78126',
  '78130',
  '78140',
  '78150',
  '78160',
  '78170',
  '78180',
  '78190',
  '78200',
  '78210',
  '78220',
  '78230',
  '78240',
  '78250',
  '78260',
  '78270',
  '78280',
  '78290',
  '78300',
  '78310',
  '78320',
  '78330',
  '78340',
  '78350',
  '78360',
  '78370',
  '78380',
  '78390',
  '78400',
  '78410',
  '78420',
  '78430',
  '78440',
  '78450',
  '78460',
  '78470',
  '78480',
  '78490',
  '78500',
  '78510',
  '78520',
  '78530',
  '78540',
  '78550',
  '78560',
  '78570',
  '78580',
  '78590',
  '78600',
  '78610',
  '78620',
  '78630',
  '78640',
  '78650',
  '78670',
  '78680',
  '78690',
  '78700',
  '78710',
  '78711',
  '78720',
  '78730',
  '78740',
  '78750',
  '78760',
  '78770',
  '78780',
  '78790',
  '78800',
  '78810',
  '78820',
  '78830',
  '78840',
  '78850',
  '78860',
  '78870',
  '78890',
  '78910',
  '78920',
  '78930',
  '78940',
  '78950',
  '78955',
  '78960',
  '78970',
  '78980',
  '78990',
  '80000',
  '80080',
  '80090',
  '80100',
  '80110',
  '80115',
  '80118',
  '80120',
  '80122',
  '80130',
  '80131',
  '80132',
  '80134',
  '80135',
  '80136',
  '80140',
  '80150',
  '80160',
  '80170',
  '80190',
  '80200',
  '80210',
  '80220',
  '80230',
  '80240',
  '80250',
  '80260',
  '80270',
  '80290',
  '80300',
  '80310',
  '80320',
  '80330',
  '80340',
  '80350',
  '80360',
  '80370',
  '80390',
  '80400',
  '80410',
  '80420',
  '80430',
  '80440',
  '80450',
  '80460',
  '80470',
  '80480',
  '80490',
  '80500',
  '80510',
  '80520',
  '80540',
  '80550',
  '80560',
  '80570',
  '80580',
  '80600',
  '80610',
  '80620',
  '80630',
  '80640',
  '80650',
  '80670',
  '80680',
  '80690',
  '80700',
  '80710',
  '80740',
  '80750',
  '80770',
  '80780',
  '80800',
  '80820',
  '80830',
  '80850',
  '80860',
  '80870',
  '80880',
  '80890',
  '80910',
  '80960',
  '80970',
  '80980',
  '81370',
  '81500',
  '81800',
  '82150',
  '82170',
  '82190',
  '82340',
  '82360',
  '82400',
  '83000',
  '83100',
  '83110',
  '83111',
  '83120',
  '83130',
  '83131',
  '83136',
  '83140',
  '83143',
  '83149',
  '83150',
  '83160',
  '83170',
  '83190',
  '83200',
  '83210',
  '83220',
  '83230',
  '83240',
  '83250',
  '83260',
  '83270',
  '83300',
  '83310',
  '83320',
  '83330',
  '83340',
  '83350',
  '83370',
  '83380',
  '83390',
  '83400',
  '83420',
  '83430',
  '83440',
  '83460',
  '83470',
  '83480',
  '83490',
  '83500',
  '83510',
  '83520',
  '83530',
  '83550',
  '83570',
  '83580',
  '83590',
  '83600',
  '83610',
  '83640',
  '83660',
  '83680',
  '83690',
  '83700',
  '83720',
  '83740',
  '83780',
  '83790',
  '83820',
  '83830',
  '83860',
  '83870',
  '83890',
  '83910',
  '83920',
  '83980',
  '83990',
  '84000',
  '84100',
  '84130',
  '84140',
  '84150',
  '84170',
  '84190',
  '84200',
  '84210',
  '84220',
  '84230',
  '84250',
  '84260',
  '84270',
  '84300',
  '84310',
  '84320',
  '84330',
  '84350',
  '84360',
  '84370',
  '84380',
  '84420',
  '84440',
  '84450',
  '84460',
  '84470',
  '84510',
  '84550',
  '84560',
  '84580',
  '84660',
  '84700',
  '84740',
  '84800',
  '84810',
  '84830',
  '84850',
  '84860',
  '84870',
  '85000',
  '85100',
  '85110',
  '85120',
  '85130',
  '85140',
  '85150',
  '85160',
  '85170',
  '85180',
  '85190',
  '85200',
  '85210',
  '85220',
  '85230',
  '85240',
  '85250',
  '85260',
  '85270',
  '85280',
  '85290',
  '85300',
  '85310',
  '85320',
  '85330',
  '85340',
  '85360',
  '85370',
  '85390',
  '85400',
  '85410',
  '85420',
  '85430',
  '85440',
  '85450',
  '85460',
  '85470',
  '85480',
  '85490',
  '85500',
  '85510',
  '85520',
  '85530',
  '85540',
  '85550',
  '85560',
  '85570',
  '85580',
  '85590',
  '85600',
  '85610',
  '85620',
  '85630',
  '85640',
  '85660',
  '85670',
  '85680',
  '85690',
  '85700',
  '85710',
  '85740',
  '85750',
  '85770',
  '85800',
  '86000',
  '86100',
  '86110',
  '86130',
  '86140',
  '86160',
  '86170',
  '86180',
  '86190',
  '86210',
  '86240',
  '86280',
  '86300',
  '86330',
  '86340',
  '86360',
  '86370',
  '86380',
  '86410',
  '86440',
  '86450',
  '86470',
  '86480',
  '86490',
  '86530',
  '86550',
  '86580',
  '86600',
  '86700',
  '86800',
  '87000',
  '87100',
  '87110',
  '87140',
  '87170',
  '87200',
  '87220',
  '87230',
  '87240',
  '87250',
  '87260',
  '87270',
  '87280',
  '87290',
  '87300',
  '87310',
  '87340',
  '87350',
  '87370',
  '87400',
  '87410',
  '87420',
  '87430',
  '87480',
  '87510',
  '87520',
  '87570',
  '87590',
  '87620',
  '87640',
  '87700',
  '87800',
  '87920',
  '89100',
  '89140',
  '89150',
  '89190',
  '89210',
  '89260',
  '89320',
  '89340',
  '89500',
  '89510',
  '89570',
  '89690',
  '89770',
  '91000',
  '91070',
  '91080',
  '91090',
  '91100',
  '91120',
  '91130',
  '91140',
  '91150',
  '91160',
  '91170',
  '91180',
  '91190',
  '91200',
  '91210',
  '91220',
  '91230',
  '91240',
  '91250',
  '91260',
  '91270',
  '91280',
  '91290',
  '91300',
  '91310',
  '91320',
  '91330',
  '91340',
  '91350',
  '91360',
  '91370',
  '91380',
  '91390',
  '91400',
  '91410',
  '91420',
  '91430',
  '91440',
  '91450',
  '91460',
  '91470',
  '91480',
  '91490',
  '91510',
  '91520',
  '91530',
  '91540',
  '91550',
  '91560',
  '91570',
  '91580',
  '91590',
  '91600',
  '91610',
  '91620',
  '91630',
  '91640',
  '91650',
  '91660',
  '91670',
  '91680',
  '91690',
  '91700',
  '91710',
  '91720',
  '91730',
  '91740',
  '91750',
  '91760',
  '91770',
  '91780',
  '91790',
  '91800',
  '91810',
  '91820',
  '91830',
  '91840',
  '91850',
  '91860',
  '91870',
  '91880',
  '91890',
  '91910',
  '91930',
  '91940',
  '92000',
  '92100',
  '92110',
  '92120',
  '92130',
  '92140',
  '92150',
  '92160',
  '92170',
  '92190',
  '92200',
  '92210',
  '92220',
  '92230',
  '92240',
  '92250',
  '92260',
  '92270',
  '92290',
  '92300',
  '92310',
  '92320',
  '92330',
  '92340',
  '92350',
  '92360',
  '92370',
  '92380',
  '92390',
  '92400',
  '92410',
  '92420',
  '92430',
  '92500',
  '92600',
  '92700',
  '92800',
  '93000',
  '93100',
  '93110',
  '93120',
  '93130',
  '93140',
  '93150',
  '93160',
  '93170',
  '93190',
  '93200',
  '93210',
  '93220',
  '93230',
  '93240',
  '93250',
  '93260',
  '93270',
  '93290',
  '93300',
  '93310',
  '93320',
  '93330',
  '93340',
  '93350',
  '93360',
  '93370',
  '93380',
  '93390',
  '93400',
  '93410',
  '93420',
  '93430',
  '93440',
  '93450',
  '93460',
  '93470',
  '93500',
  '93600',
  '93700',
  '93800',
  '94000',
  '94100',
  '94110',
  '94120',
  '94130',
  '94140',
  '94150',
  '94160',
  '94170',
  '94190',
  '94200',
  '94210',
  '94220',
  '94230',
  '94240',
  '94250',
  '94260',
  '94270',
  '94290',
  '94300',
  '94310',
  '94320',
  '94340',
  '94350',
  '94360',
  '94370',
  '94380',
  '94390',
  '94400',
  '94410',
  '94420',
  '94430',
  '94440',
  '94450',
  '94460',
  '94470',
  '94480',
  '94490',
  '94500',
  '94510',
  '94520',
  '94550',
  '94600',
  '94700',
  '94800',
  '94880',
  '95000',
  '95100',
  '95110',
  '95120',
  '95130',
  '95140',
  '95150',
  '95160',
  '95170',
  '95180',
  '95190',
  '95200',
  '95210',
  '95220',
  '95230',
  '95240',
  '95250',
  '95260',
  '95270',
  '95280',
  '95290',
  '95300',
  '95310',
  '95320',
  '95330',
  '95340',
  '95350',
  '95360',
  '95370',
  '95380',
  '95390',
  '95400',
  '95410',
  '95420',
  '95430',
  '95440',
  '95450',
  '95460',
  '95470',
  '95480',
  '95490',
  '95500',
  '95510',
  '95520',
  '95530',
  '95540',
  '95550',
  '95560',
  '95570',
  '95580',
  '95590',
  '95600',
  '95610',
  '95620',
  '95630',
  '95640',
  '95650',
  '95660',
  '95670',
  '95680',
  '95690',
  '95700',
  '95710',
  '95720',
  '95740',
  '95750',
  '95760',
  '95770',
  '95780',
  '95800',
  '95810',
  '95820',
  '95830',
  '95840',
  '95850',
  '95870',
  '95880',
])

export const PROXISERVE_ELIGIBLE_ZIPCODES_BY_HEATING_TYPE: Record<ProxiserveHeatingType, Set<string>> = {
  gas: gasZipcodes,
  propane: gasZipcodes,
  oil: new Set([
    '13160',
    '13370',
    '13430',
    '13440',
    '13550',
    '13560',
    '13570',
    '13630',
    '13660',
    '13670',
    '13690',
    '13750',
    '13810',
    '13870',
    '13910',
    '13940',
    '22160',
    '22300',
    '22310',
    '22420',
    '22560',
    '22700',
    '22730',
    '22780',
    '22810',
    '23430',
    '29190',
    '29200',
    '29217',
    '29233',
    '29241',
    '29246',
    '29250',
    '29252',
    '29260',
    '29280',
    '29290',
    '29400',
    '29410',
    '29420',
    '29430',
    '29440',
    '29450',
    '29460',
    '29470',
    '29480',
    '29490',
    '29530',
    '29590',
    '29600',
    '29610',
    '29620',
    '29630',
    '29640',
    '29650',
    '29660',
    '29670',
    '29680',
    '29690',
    '29800',
    '29810',
    '29820',
    '29830',
    '29840',
    '29850',
    '29860',
    '29870',
    '29880',
    '29890',
    '29990',
    '30126',
    '30131',
    '30133',
    '30150',
    '30290',
    '30390',
    '30400',
    '30650',
    '32340',
    '32480',
    '32700',
    '33000',
    '33115',
    '33120',
    '33138',
    '33260',
    '33380',
    '33470',
    '33510',
    '33680',
    '33740',
    '33770',
    '33830',
    '33950',
    '33970',
    '33980',
    '40160',
    '40320',
    '40460',
    '40600',
    '40800',
    '44270',
    '44310',
    '44370',
    '44580',
    '44650',
    '44760',
    '47000',
    '47110',
    '47130',
    '47140',
    '47150',
    '47160',
    '47190',
    '47210',
    '47220',
    '47230',
    '47240',
    '47260',
    '47270',
    '47290',
    '47300',
    '47310',
    '47320',
    '47330',
    '47340',
    '47360',
    '47370',
    '47380',
    '47390',
    '47400',
    '47410',
    '47430',
    '47440',
    '47450',
    '47470',
    '47480',
    '47500',
    '47510',
    '47520',
    '47550',
    '47600',
    '49000',
    '49070',
    '49080',
    '49100',
    '49110',
    '49120',
    '49122',
    '49123',
    '49124',
    '49125',
    '49130',
    '49140',
    '49150',
    '49160',
    '49170',
    '49190',
    '49220',
    '49240',
    '49250',
    '49260',
    '49270',
    '49280',
    '49290',
    '49300',
    '49310',
    '49320',
    '49330',
    '49340',
    '49350',
    '49360',
    '49370',
    '49380',
    '49390',
    '49400',
    '49410',
    '49420',
    '49430',
    '49440',
    '49450',
    '49460',
    '49480',
    '49490',
    '49500',
    '49510',
    '49520',
    '49540',
    '49560',
    '49570',
    '49590',
    '49600',
    '49610',
    '49620',
    '49630',
    '49640',
    '49650',
    '49670',
    '49680',
    '49690',
    '49700',
    '49730',
    '49740',
    '49750',
    '49770',
    '49800',
    '54000',
    '54100',
    '54110',
    '54112',
    '54113',
    '54114',
    '54115',
    '54116',
    '54118',
    '54119',
    '54120',
    '54122',
    '54123',
    '54129',
    '54130',
    '54134',
    '54136',
    '54140',
    '54160',
    '54170',
    '54180',
    '54200',
    '54210',
    '54220',
    '54230',
    '54250',
    '54270',
    '54280',
    '54290',
    '54300',
    '54320',
    '54330',
    '54340',
    '54360',
    '54370',
    '54380',
    '54385',
    '54390',
    '54410',
    '54420',
    '54425',
    '54450',
    '54460',
    '54470',
    '54480',
    '54500',
    '54510',
    '54520',
    '54540',
    '54550',
    '54570',
    '54600',
    '54610',
    '54630',
    '54670',
    '54690',
    '54700',
    '54710',
    '54740',
    '54760',
    '54770',
    '54820',
    '54830',
    '54840',
    '54850',
    '54930',
    '54940',
    '54950',
    '54990',
    '62100',
    '62126',
    '62132',
    '62137',
    '62142',
    '62152',
    '62155',
    '62164',
    '62170',
    '62176',
    '62179',
    '62180',
    '62185',
    '62187',
    '62200',
    '62224',
    '62230',
    '62231',
    '62240',
    '62250',
    '62280',
    '62340',
    '62360',
    '62380',
    '62480',
    '62520',
    '62600',
    '62610',
    '62630',
    '62650',
    '62720',
    '62730',
    '62780',
    '62830',
    '62850',
    '62890',
    '62930',
    '64000',
    '64110',
    '64121',
    '64140',
    '64150',
    '64160',
    '64170',
    '64190',
    '64230',
    '64260',
    '64290',
    '64300',
    '64320',
    '64330',
    '64350',
    '64360',
    '64370',
    '64400',
    '64410',
    '64420',
    '64450',
    '64460',
    '64510',
    '64530',
    '64660',
    '64680',
    '64800',
    '64870',
    '65000',
    '65100',
    '65270',
    '65290',
    '65310',
    '65320',
    '65360',
    '65380',
    '65390',
    '65420',
    '65430',
    '65460',
    '65490',
    '65500',
    '65560',
    '65600',
    '65690',
    '65700',
    '65800',
    '67000',
    '67100',
    '67112',
    '67113',
    '67114',
    '67115',
    '67116',
    '67117',
    '67118',
    '67120',
    '67130',
    '67140',
    '67150',
    '67170',
    '67190',
    '67200',
    '67201',
    '67202',
    '67203',
    '67204',
    '67205',
    '67206',
    '67207',
    '67210',
    '67220',
    '67230',
    '67240',
    '67270',
    '67280',
    '67300',
    '67310',
    '67330',
    '67350',
    '67370',
    '67380',
    '67390',
    '67400',
    '67410',
    '67420',
    '67440',
    '67450',
    '67460',
    '67480',
    '67490',
    '67500',
    '67520',
    '67530',
    '67540',
    '67550',
    '67560',
    '67570',
    '67590',
    '67600',
    '67610',
    '67620',
    '67640',
    '67650',
    '67670',
    '67680',
    '67700',
    '67710',
    '67720',
    '67730',
    '67750',
    '67760',
    '67770',
    '67790',
    '67800',
    '67810',
    '67820',
    '67840',
    '67850',
    '67860',
    '67870',
    '67880',
    '67920',
    '67960',
    '67980',
    '67990',
    '68000',
    '68040',
    '68100',
    '68110',
    '68116',
    '68118',
    '68120',
    '68121',
    '68124',
    '68125',
    '68126',
    '68127',
    '68128',
    '68130',
    '68140',
    '68150',
    '68160',
    '68170',
    '68180',
    '68190',
    '68200',
    '68210',
    '68220',
    '68230',
    '68240',
    '68250',
    '68260',
    '68270',
    '68280',
    '68290',
    '68300',
    '68310',
    '68320',
    '68330',
    '68340',
    '68350',
    '68360',
    '68370',
    '68380',
    '68390',
    '68400',
    '68420',
    '68440',
    '68460',
    '68470',
    '68480',
    '68490',
    '68500',
    '68510',
    '68520',
    '68530',
    '68540',
    '68550',
    '68560',
    '68570',
    '68580',
    '68590',
    '68600',
    '68610',
    '68620',
    '68630',
    '68640',
    '68650',
    '68660',
    '68680',
    '68690',
    '68700',
    '68720',
    '68730',
    '68740',
    '68750',
    '68760',
    '68770',
    '68780',
    '68790',
    '68800',
    '68820',
    '68830',
    '68840',
    '68850',
    '68870',
    '68890',
    '68910',
    '68920',
    '68950',
    '68960',
    '68970',
    '68980',
    '68990',
    '76111',
    '76117',
    '76119',
    '76200',
    '76220',
    '76260',
    '76270',
    '76340',
    '76370',
    '76390',
    '76400',
    '76440',
    '76450',
    '76460',
    '76470',
    '76510',
    '76540',
    '76550',
    '76560',
    '76590',
    '76630',
    '76660',
    '76720',
    '76730',
    '76740',
    '76760',
    '76780',
    '76810',
    '76860',
    '76870',
    '76880',
    '76890',
    '76910',
    '76950',
    '76970',
    '76980',
    '82150',
    '82190',
    '82340',
    '82360',
    '82400',
    '84000',
    '84100',
    '84130',
    '84140',
    '84150',
    '84170',
    '84190',
    '84200',
    '84210',
    '84220',
    '84230',
    '84250',
    '84260',
    '84270',
    '84300',
    '84310',
    '84320',
    '84330',
    '84350',
    '84360',
    '84370',
    '84380',
    '84420',
    '84440',
    '84450',
    '84460',
    '84470',
    '84510',
    '84550',
    '84560',
    '84580',
    '84660',
    '84700',
    '84740',
    '84800',
    '84810',
    '84830',
    '84850',
    '84860',
    '84870',
    '85000',
    '85100',
    '85110',
    '85120',
    '85130',
    '85140',
    '85150',
    '85160',
    '85170',
    '85180',
    '85190',
    '85200',
    '85210',
    '85220',
    '85230',
    '85240',
    '85250',
    '85260',
    '85270',
    '85280',
    '85290',
    '85300',
    '85310',
    '85320',
    '85330',
    '85340',
    '85360',
    '85370',
    '85390',
    '85400',
    '85410',
    '85420',
    '85430',
    '85440',
    '85450',
    '85460',
    '85470',
    '85480',
    '85490',
    '85500',
    '85510',
    '85520',
    '85530',
    '85540',
    '85550',
    '85560',
    '85570',
    '85580',
    '85590',
    '85600',
    '85620',
    '85630',
    '85640',
    '85670',
    '85680',
    '85690',
    '85700',
    '85710',
    '85740',
    '85750',
    '85770',
    '85800',
    '87000',
    '87100',
    '87110',
    '87140',
    '87170',
    '87200',
    '87220',
    '87230',
    '87240',
    '87250',
    '87260',
    '87270',
    '87280',
    '87290',
    '87300',
    '87310',
    '87340',
    '87350',
    '87370',
    '87400',
    '87410',
    '87420',
    '87430',
    '87480',
    '87510',
    '87520',
    '87570',
    '87590',
    '87620',
    '87640',
    '87700',
    '87800',
    '87920',
  ]),
  heatPump: new Set([
    '02100',
    '02420',
    '02430',
    '02440',
    '02480',
    '02490',
    '02520',
    '02590',
    '02640',
    '02680',
    '02690',
    '02760',
    '02790',
    '08000',
    '08090',
    '08110',
    '08120',
    '08130',
    '08140',
    '08150',
    '08160',
    '08170',
    '08200',
    '08210',
    '08220',
    '08230',
    '08240',
    '08250',
    '08260',
    '08270',
    '08290',
    '08300',
    '08310',
    '08320',
    '08330',
    '08350',
    '08360',
    '08370',
    '08380',
    '08390',
    '08400',
    '08410',
    '08430',
    '08440',
    '08450',
    '08460',
    '08500',
    '08600',
    '08700',
    '08800',
    '10000',
    '10100',
    '10110',
    '10120',
    '10130',
    '10140',
    '10150',
    '10160',
    '10170',
    '10180',
    '10190',
    '10200',
    '10210',
    '10220',
    '10230',
    '10240',
    '10250',
    '10260',
    '10270',
    '10280',
    '10290',
    '10300',
    '10310',
    '10320',
    '10330',
    '10340',
    '10350',
    '10360',
    '10370',
    '10380',
    '10390',
    '10400',
    '10410',
    '10420',
    '10430',
    '10440',
    '10450',
    '10500',
    '10510',
    '10600',
    '10700',
    '10800',
    '13160',
    '13370',
    '13430',
    '13440',
    '13550',
    '13560',
    '13570',
    '13630',
    '13660',
    '13670',
    '13690',
    '13750',
    '13810',
    '13870',
    '13910',
    '13940',
    '17000',
    '17100',
    '17110',
    '17111',
    '17113',
    '17132',
    '17137',
    '17138',
    '17139',
    '17140',
    '17170',
    '17180',
    '17190',
    '17200',
    '17220',
    '17230',
    '17250',
    '17290',
    '17300',
    '17310',
    '17320',
    '17330',
    '17340',
    '17350',
    '17370',
    '17380',
    '17390',
    '17400',
    '17410',
    '17420',
    '17430',
    '17440',
    '17450',
    '17480',
    '17530',
    '17540',
    '17550',
    '17560',
    '17570',
    '17580',
    '17590',
    '17610',
    '17620',
    '17630',
    '17640',
    '17670',
    '17690',
    '17700',
    '17730',
    '17740',
    '17750',
    '17780',
    '17810',
    '17840',
    '17870',
    '17880',
    '17890',
    '17920',
    '17940',
    '22160',
    '22300',
    '22310',
    '22420',
    '22560',
    '22700',
    '22730',
    '22780',
    '22810',
    '29190',
    '29200',
    '29217',
    '29233',
    '29241',
    '29246',
    '29250',
    '29252',
    '29260',
    '29280',
    '29290',
    '29400',
    '29410',
    '29420',
    '29430',
    '29440',
    '29450',
    '29460',
    '29470',
    '29480',
    '29490',
    '29530',
    '29590',
    '29600',
    '29610',
    '29620',
    '29630',
    '29640',
    '29650',
    '29660',
    '29670',
    '29680',
    '29690',
    '29800',
    '29810',
    '29820',
    '29830',
    '29840',
    '29850',
    '29860',
    '29870',
    '29880',
    '29890',
    '29990',
    '30126',
    '30131',
    '30133',
    '30150',
    '30290',
    '30390',
    '30400',
    '30650',
    '32340',
    '32480',
    '32700',
    '40130',
    '40140',
    '40150',
    '40220',
    '40230',
    '40300',
    '40320',
    '40390',
    '40440',
    '40480',
    '40510',
    '40530',
    '40800',
    '44270',
    '44310',
    '44580',
    '44650',
    '44760',
    '47000',
    '47110',
    '47130',
    '47140',
    '47150',
    '47160',
    '47190',
    '47210',
    '47220',
    '47230',
    '47240',
    '47260',
    '47270',
    '47290',
    '47300',
    '47310',
    '47320',
    '47330',
    '47340',
    '47360',
    '47370',
    '47380',
    '47390',
    '47400',
    '47410',
    '47430',
    '47440',
    '47450',
    '47470',
    '47480',
    '47500',
    '47510',
    '47520',
    '47550',
    '47600',
    '51000',
    '51120',
    '51130',
    '51190',
    '51210',
    '51230',
    '51240',
    '51250',
    '51260',
    '51270',
    '51290',
    '51300',
    '51310',
    '51320',
    '51330',
    '51340',
    '51460',
    '51470',
    '51510',
    '51520',
    '51600',
    '51700',
    '51800',
    '52100',
    '62100',
    '62126',
    '62132',
    '62137',
    '62142',
    '62152',
    '62155',
    '62164',
    '62170',
    '62176',
    '62179',
    '62180',
    '62185',
    '62187',
    '62200',
    '62224',
    '62230',
    '62231',
    '62240',
    '62250',
    '62280',
    '62340',
    '62360',
    '62380',
    '62480',
    '62520',
    '62600',
    '62610',
    '62630',
    '62650',
    '62720',
    '62730',
    '62780',
    '62830',
    '62850',
    '62890',
    '62930',
    '64000',
    '64100',
    '64110',
    '64121',
    '64122',
    '64140',
    '64150',
    '64160',
    '64170',
    '64190',
    '64200',
    '64210',
    '64230',
    '64240',
    '64250',
    '64260',
    '64290',
    '64300',
    '64310',
    '64320',
    '64330',
    '64340',
    '64350',
    '64360',
    '64370',
    '64400',
    '64410',
    '64420',
    '64450',
    '64460',
    '64480',
    '64500',
    '64510',
    '64520',
    '64530',
    '64600',
    '64640',
    '64660',
    '64680',
    '64700',
    '64780',
    '64800',
    '64870',
    '64990',
    '65000',
    '65100',
    '65270',
    '65290',
    '65310',
    '65320',
    '65360',
    '65380',
    '65390',
    '65420',
    '65430',
    '65460',
    '65490',
    '65500',
    '65560',
    '65600',
    '65690',
    '65700',
    '65800',
    '80000',
    '80080',
    '80090',
    '80100',
    '80110',
    '80115',
    '80118',
    '80120',
    '80122',
    '80130',
    '80131',
    '80132',
    '80134',
    '80135',
    '80136',
    '80140',
    '80150',
    '80160',
    '80170',
    '80190',
    '80200',
    '80210',
    '80220',
    '80230',
    '80240',
    '80250',
    '80260',
    '80270',
    '80290',
    '80300',
    '80310',
    '80320',
    '80330',
    '80340',
    '80350',
    '80360',
    '80370',
    '80390',
    '80400',
    '80410',
    '80420',
    '80430',
    '80440',
    '80450',
    '80460',
    '80470',
    '80480',
    '80490',
    '80500',
    '80510',
    '80520',
    '80540',
    '80550',
    '80560',
    '80570',
    '80580',
    '80600',
    '80610',
    '80620',
    '80630',
    '80640',
    '80650',
    '80670',
    '80680',
    '80690',
    '80700',
    '80710',
    '80740',
    '80750',
    '80770',
    '80780',
    '80800',
    '80820',
    '80830',
    '80850',
    '80860',
    '80870',
    '80880',
    '80890',
    '80910',
    '80960',
    '80970',
    '80980',
    '82150',
    '82190',
    '82340',
    '82360',
    '82400',
    '83000',
    '83100',
    '83110',
    '83111',
    '83120',
    '83130',
    '83131',
    '83136',
    '83140',
    '83143',
    '83149',
    '83150',
    '83160',
    '83170',
    '83190',
    '83200',
    '83210',
    '83220',
    '83230',
    '83240',
    '83250',
    '83260',
    '83270',
    '83300',
    '83310',
    '83320',
    '83330',
    '83340',
    '83350',
    '83370',
    '83380',
    '83390',
    '83400',
    '83420',
    '83430',
    '83440',
    '83460',
    '83470',
    '83480',
    '83490',
    '83500',
    '83510',
    '83520',
    '83530',
    '83550',
    '83570',
    '83580',
    '83590',
    '83600',
    '83610',
    '83640',
    '83660',
    '83680',
    '83690',
    '83700',
    '83720',
    '83740',
    '83780',
    '83790',
    '83820',
    '83830',
    '83860',
    '83870',
    '83890',
    '83910',
    '83920',
    '83980',
    '83990',
    '84000',
    '84100',
    '84130',
    '84140',
    '84150',
    '84170',
    '84190',
    '84200',
    '84210',
    '84220',
    '84230',
    '84250',
    '84260',
    '84270',
    '84300',
    '84310',
    '84320',
    '84330',
    '84350',
    '84360',
    '84370',
    '84380',
    '84420',
    '84440',
    '84450',
    '84460',
    '84470',
    '84510',
    '84550',
    '84560',
    '84580',
    '84660',
    '84700',
    '84740',
    '84800',
    '84810',
    '84830',
    '84850',
    '84860',
    '84870',
    '85000',
    '85100',
    '85110',
    '85120',
    '85130',
    '85140',
    '85150',
    '85160',
    '85170',
    '85180',
    '85190',
    '85200',
    '85210',
    '85220',
    '85230',
    '85240',
    '85250',
    '85260',
    '85270',
    '85280',
    '85290',
    '85300',
    '85310',
    '85320',
    '85330',
    '85340',
    '85360',
    '85370',
    '85390',
    '85400',
    '85410',
    '85420',
    '85430',
    '85440',
    '85450',
    '85460',
    '85470',
    '85480',
    '85490',
    '85500',
    '85510',
    '85520',
    '85530',
    '85540',
    '85550',
    '85560',
    '85570',
    '85580',
    '85590',
    '85600',
    '85620',
    '85630',
    '85640',
    '85670',
    '85680',
    '85690',
    '85700',
    '85710',
    '85740',
    '85750',
    '85770',
    '85800',
    '86000',
    '86100',
    '86110',
    '86130',
    '86140',
    '86160',
    '86170',
    '86180',
    '86190',
    '86210',
    '86240',
    '86280',
    '86300',
    '86330',
    '86340',
    '86360',
    '86370',
    '86380',
    '86410',
    '86440',
    '86450',
    '86470',
    '86480',
    '86490',
    '86530',
    '86550',
    '86580',
    '86600',
    '86700',
    '86800',
    '89100',
    '89140',
    '89150',
    '89190',
    '89210',
    '89260',
    '89320',
    '89340',
    '89500',
    '89510',
    '89570',
    '89690',
    '89770',
  ]),
  reversibleAirConditioning: new Set([
    '02100',
    '02420',
    '02430',
    '02440',
    '02480',
    '02490',
    '02520',
    '02590',
    '02640',
    '02680',
    '02690',
    '02760',
    '02790',
    '08000',
    '08090',
    '08110',
    '08120',
    '08130',
    '08140',
    '08150',
    '08160',
    '08170',
    '08200',
    '08210',
    '08220',
    '08230',
    '08240',
    '08250',
    '08260',
    '08270',
    '08290',
    '08300',
    '08310',
    '08320',
    '08330',
    '08350',
    '08360',
    '08370',
    '08380',
    '08390',
    '08400',
    '08410',
    '08430',
    '08440',
    '08450',
    '08460',
    '08500',
    '08600',
    '08700',
    '08800',
    '10000',
    '10100',
    '10110',
    '10120',
    '10130',
    '10140',
    '10150',
    '10160',
    '10170',
    '10180',
    '10190',
    '10200',
    '10210',
    '10220',
    '10230',
    '10240',
    '10250',
    '10260',
    '10270',
    '10280',
    '10290',
    '10300',
    '10310',
    '10320',
    '10330',
    '10340',
    '10350',
    '10360',
    '10370',
    '10380',
    '10390',
    '10400',
    '10410',
    '10420',
    '10430',
    '10440',
    '10450',
    '10500',
    '10510',
    '10600',
    '10700',
    '10800',
    '17000',
    '17100',
    '17110',
    '17111',
    '17113',
    '17132',
    '17137',
    '17138',
    '17139',
    '17140',
    '17170',
    '17180',
    '17190',
    '17200',
    '17220',
    '17230',
    '17250',
    '17290',
    '17300',
    '17310',
    '17320',
    '17330',
    '17340',
    '17350',
    '17370',
    '17380',
    '17390',
    '17400',
    '17410',
    '17420',
    '17430',
    '17440',
    '17450',
    '17480',
    '17530',
    '17540',
    '17550',
    '17560',
    '17570',
    '17580',
    '17590',
    '17610',
    '17620',
    '17630',
    '17640',
    '17670',
    '17690',
    '17700',
    '17730',
    '17740',
    '17750',
    '17780',
    '17810',
    '17840',
    '17870',
    '17880',
    '17890',
    '17920',
    '17940',
    '40130',
    '40140',
    '40150',
    '40220',
    '40230',
    '40300',
    '40390',
    '40440',
    '40480',
    '40510',
    '40530',
    '51000',
    '51120',
    '51130',
    '51190',
    '51210',
    '51230',
    '51240',
    '51250',
    '51260',
    '51270',
    '51290',
    '51300',
    '51310',
    '51320',
    '51330',
    '51340',
    '51460',
    '51470',
    '51510',
    '51520',
    '51600',
    '51700',
    '51800',
    '52100',
    '62100',
    '62126',
    '62132',
    '62137',
    '62142',
    '62152',
    '62155',
    '62164',
    '62170',
    '62176',
    '62179',
    '62180',
    '62185',
    '62187',
    '62200',
    '62224',
    '62230',
    '62231',
    '62240',
    '62250',
    '62280',
    '62340',
    '62360',
    '62380',
    '62480',
    '62520',
    '62600',
    '62610',
    '62630',
    '62650',
    '62720',
    '62730',
    '62780',
    '62830',
    '62850',
    '62890',
    '62930',
    '64100',
    '64122',
    '64200',
    '64210',
    '64240',
    '64250',
    '64310',
    '64340',
    '64480',
    '64500',
    '64520',
    '64600',
    '64640',
    '64700',
    '64780',
    '64990',
    '80000',
    '80080',
    '80090',
    '80100',
    '80110',
    '80115',
    '80118',
    '80120',
    '80122',
    '80130',
    '80131',
    '80132',
    '80134',
    '80135',
    '80136',
    '80140',
    '80150',
    '80160',
    '80170',
    '80190',
    '80200',
    '80210',
    '80220',
    '80230',
    '80240',
    '80250',
    '80260',
    '80270',
    '80290',
    '80300',
    '80310',
    '80320',
    '80330',
    '80340',
    '80350',
    '80360',
    '80370',
    '80390',
    '80400',
    '80410',
    '80420',
    '80430',
    '80440',
    '80450',
    '80460',
    '80470',
    '80480',
    '80490',
    '80500',
    '80510',
    '80520',
    '80540',
    '80550',
    '80560',
    '80570',
    '80580',
    '80600',
    '80610',
    '80620',
    '80630',
    '80640',
    '80650',
    '80670',
    '80680',
    '80690',
    '80700',
    '80710',
    '80740',
    '80750',
    '80770',
    '80780',
    '80800',
    '80820',
    '80830',
    '80850',
    '80860',
    '80870',
    '80880',
    '80890',
    '80910',
    '80960',
    '80970',
    '80980',
    '83000',
    '83100',
    '83110',
    '83111',
    '83120',
    '83130',
    '83131',
    '83136',
    '83140',
    '83143',
    '83149',
    '83150',
    '83160',
    '83170',
    '83190',
    '83200',
    '83210',
    '83220',
    '83230',
    '83240',
    '83250',
    '83260',
    '83270',
    '83300',
    '83310',
    '83320',
    '83330',
    '83340',
    '83350',
    '83370',
    '83380',
    '83390',
    '83400',
    '83420',
    '83430',
    '83440',
    '83460',
    '83470',
    '83480',
    '83490',
    '83500',
    '83510',
    '83520',
    '83530',
    '83550',
    '83570',
    '83580',
    '83590',
    '83600',
    '83610',
    '83640',
    '83660',
    '83680',
    '83690',
    '83700',
    '83720',
    '83740',
    '83780',
    '83790',
    '83820',
    '83830',
    '83860',
    '83870',
    '83890',
    '83910',
    '83920',
    '83980',
    '83990',
    '86000',
    '86100',
    '86110',
    '86130',
    '86140',
    '86160',
    '86170',
    '86180',
    '86190',
    '86210',
    '86240',
    '86280',
    '86300',
    '86330',
    '86340',
    '86360',
    '86370',
    '86380',
    '86410',
    '86440',
    '86450',
    '86470',
    '86480',
    '86490',
    '86530',
    '86550',
    '86580',
    '86600',
    '86700',
    '86800',
    '89100',
    '89140',
    '89150',
    '89190',
    '89210',
    '89260',
    '89320',
    '89340',
    '89500',
    '89510',
    '89570',
    '89690',
    '89770',
  ]),
}
